import { render, staticRenderFns } from "./ArchiveCitationValidation.vue?vue&type=template&id=2213fb5c"
import script from "./ArchiveCitationValidation.vue?vue&type=script&lang=ts"
export * from "./ArchiveCitationValidation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports